import i18n from '../translations/i18n';

const validate = (values, props) => {
	let lng = props.lng;
	const errors = {}
	if (!values.firstName) {
		errors.firstName = 'Required'
	}
	if (!values.lastName) {
		errors.lastName = 'Required'
	}
	if (!values.email) {
		errors.email = 'Required'
	} else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
		errors.email = i18n.t('validation.email_validation', {lng})
	}
	if (!values.phone) {
		errors.phone = 'Required'
	}
	if (values.service !== "coaching") {
		if (!values.sourceLanguage) {
			errors.sourceLanguage = 'Required'
		}  
		if (!values.targetLanguage) {
			errors.targetLanguage = 'Required'
		} else if (values.sourceLanguage && values.targetLanguage) {
			if (values.sourceLanguage === values.targetLanguage) {
				errors.targetLanguage = i18n.t('validation.languages_validation', {lng})
				}
		}

		if (values.service === "official" ) {
			if (!values.countryOfOrigin) {
				errors.countryOfOrigin = 'Required'
			}
			if (!values.processingCountry) {
				errors.processingCountry = 'Required'
			}
			if (!values.requestOrigin) {
				errors.requestOrigin = 'Required'
			}
		}

		if (values.service === "translation" ) {
			if (!values.specialtyField) {
				errors.specialtyField = 'Required'
			}
			if (!values.targetCountry) {
				errors.targetCountry = 'Required'
			}
			if (!values.glossaries) {
				errors.glossaries = 'Required'
			}
			if (values.certification===true) {
				if (!values.requestOrigin) {
					errors.requestOrigin = 'Required'
				}
			}
		}

		if (values.service === "interpreting" ) {
			if (!values.interpretingDuration) {
				errors.interpretingDuration = 'Required'
			}
			if (!values.audienceNumber) {
				errors.audienceNumber = 'Required'
			}
			if (!values.interpretorsNumber) {
				errors.interpretorsNumber = 'Required'
			}
			if (!values.interpretingType) {
				errors.interpretingType = 'Required'
			}
			if (!values.interpretingPurpose) {
				errors.interpretingPurpose = 'Required'
			}
			if (!values.sourceAvailable) {
				errors.sourceAvailable = 'Required'
			}
			if (!values.desiredStartDate) {
				errors.desiredStartDate = 'Required'
			}
			if (!values.desiredEndDate) {
				errors.desiredEndDate = 'Required'
			}
			if (!values.interpretingLocation) {
				errors.interpretingLocation = 'Required'
			}
		}

	} else if (values.service === "coaching") {
		if (!values.coachingPackage) {
			errors.coachingPackage = 'Required'
		}
		if (!values.coachingLanguage) {
			errors.coachingLanguage = 'Required'
		}
		if (!values.myAvailabilities) {
			errors.myAvailabilities = 'Required'
		}
		if (!values.desiredStartDate) {
			errors.desiredStartDate = 'Required'
		}
		if (!values.desiredEndDate) {
			errors.desiredEndDate = 'Required'
		}
		if (!values.coachingLevel) {
			errors.coachingLevel = 'Required'
		}
		if (!values.coachingGoals) {
			errors.coachingGoals = 'Required'
		}
	}

	if (values.courierServiceDelivery === true || values.registeredLetterDelivery === true || values.trackedLetterDelivery === true) {
		if (!values.shippingaddressline1) {
			errors.shippingaddressline1 = 'Required'
		}
		if (!values.shippingpostalcode) {
			errors.shippingpostalcode = 'Required'
		}
		if (!values.shippingcity) {
			errors.shippingcity = 'Required'
		}
		if (!values.shippingCountry) {
			errors.shippingCountry = 'Required'
		}

		if (values.courierServiceDelivery === true) {
			if (!values.courierOption) {
				errors.courierOption = 'Required'
			}
		}
	}

	if (!values.addressline1) {
		errors.addressline1 = 'Required'
	}
	if (!values.postalcode) {
		errors.postalcode = 'Required'
	}
	if (!values.city) {
		errors.city = 'Required'
	}
	if (!values.billingCountry) {
		errors.billingCountry = 'Required'
	}

	if (!values.termsAndConditions) {
		errors.termsAndConditions = 'Required'
	}

	return errors
}

export default validate


// WEBPACK FOOTER //
// ./src/validations/validate.js